import { Difficulty } from "shared/games/Difficulty";
import qs from "query-string";

/**
 * Items to user scenario
 */
export const apiRecombeeItemsToUserScenario = (
  params: ApiRecombeeItemsToUserScenarioParams
) =>
  qs.stringifyUrl({
    url: `/api/recombee/items-to-user-scenario`,
    query: { ...params },
  });
export interface ApiRecombeeItemsToUserScenarioResponse {
  recomm_id: string;
  recomms: null[];
}
export interface ApiRecombeeItemsToUserScenarioParams {
  scenario_id: string;
  count: number;
}

/**
 * Items to item scenario
 */
export const apiRecombeeItemsToiItemScenario = (
  params: ApiRecombeeItemsToItemScenarioParams
) =>
  qs.stringifyUrl({
    url: `/api/recombee/items-to-item-scenario`,
    query: { ...params },
  });
export interface ApiRecombeeItemsToItemScenarioResponse {
  recomm_id: string;
  recomms: null[];
}
export interface ApiRecombeeItemsToItemScenarioParams {
  scenario_id: string;
  item_id: string;
  count: number;
}

/**
 * Update user preferences
 */
export const apiRecombeeUpdateUserPreferences = `/api/recombee/update-user-preferences`;
export interface ApiRecombeeUpdateUserPreferencesParams {
  difficulty_preference: Difficulty;
}
export type ApiRecombeeUpdateUserPreferencesResponse = void;

/***
 * Details viewed
 */
export const apiRecombeeDetailsViewed = (itemId: string) =>
  `/api/recombee/details-viewed/${itemId}`;
export type ApiRecombeeDetailsViewedResponse = void;
export interface ApiRecombeeDetailsViewedParams {}

/**
 * Purchase
 */
export const apiRecombeePurchase = (itemId: string) =>
  `/api/recombee/purchase/${itemId}`;
export type ApiRecombeePurchaseResponse = void;
export interface ApiRecombeePurchaseParams {}
